export default __webpack_public_path__ + "static/media/benefit_14@2x.8825be32.png";